(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/prescript.js'); 
(function(_, svs) {
  'use strict';

  svs.spelpaus = svs.spelpaus || {};

  svs.spelpaus.app = new Backbone.Marionette.Application({
    region: '#mainRegion',

    onStart: function() {
      svs.spelpaus.logger = new svs.core.log.Logger('module:spelpaus');
      svs.spelpaus.router = new svs.spelpaus.Router();
      Backbone.history.start({ pushState: true, root: svs.core.data.baseUrl });
    }
  });

  svs.spelpaus.behaviours = svs.spelpaus.behaviours || {};
  svs.spelpaus.views = svs.spelpaus.views || {};
  svs.spelpaus.models = svs.spelpaus.models || {};
  svs.spelpaus.collections = svs.spelpaus.collections || {};
})(this._, this.svs);

 })(window);